module.exports = __webpack_public_path__ + "img/icon-feedback.295bc31c.png";